/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AcceptFriendRequestResponse,
  ApiError,
  CancelFriendRequestResponse,
  CreateProfileResponse,
  CreateUserBasicInfoResponse,
  CreateUserWork200,
  CreateUserWorkBody,
  DeleteFriendResponse,
  DisjoinWebinarResponse,
  GetCurrentMonthPointsRankingParams,
  GetCurrentMonthPointsRankingResponse,
  GetFriendsAndFriendsRequestsResponse,
  GetHistoryPointsRankingParams,
  GetHistoryPointsRankingResponse,
  GetMyUserResponse,
  GetUserCatalogResponse,
  GetUserCoachStatusParams,
  GetUserCoachStatusResponse,
  GetUserConfigResponse,
  GetUserHabitResponse,
  GetUserPillsParams,
  GetUserPillsResponse,
  GetUserPillsShowcaseParams,
  GetUserPillsShowcaseResponse,
  GetUserSportsResponse,
  GetUserStatsCalendarParams,
  GetUserStatsCalendarResponse,
  GetUserStatsHistoryParams,
  GetUserStatsHistoryResponse,
  GetUserWorkOfTheDayResponse,
  GetUserWorkResponse,
  JoinWebinarResponse,
  PickCreateProfileRequestExcludeKeyofCreateProfileRequestId,
  PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID,
  PickDisjoinWebinarRequestWebinarId,
  PickJoinWebinarRequestWebinarId,
  PickRegisterRequestNameOrPartnerCode,
  PickUpdateAccountFieldsRequestNameOrLangOrImage,
  PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities,
  PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID,
  PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened,
  ReadUserPillResponse,
  RegisterUser200,
  RejectFriendRequestResponse,
  SaveUserSports200,
  SaveUserSportsBody,
  SendFriendRequestResponse,
  ToggleShowCompanyResponse,
  ToggleShowNameResponse,
  UnlockUserPillResponse,
  UpdateAccountFieldsResponse,
  UpdateHabitCommitmentResponse,
  UpdateProfileFieldsResponse,
  UpdateProfileNotificationsResponse,
  UpdateUserHabitCommitmentBody,
  UpdateUserHealthinessIdentityBody,
  UpdateUserHealthinessIdentityResponse,
  Work
} from '.././schemas'
import { customAxiosInstance } from '../../orval-axios-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const createProfile = (
    pickCreateProfileRequestExcludeKeyofCreateProfileRequestId: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<CreateProfileResponse>(
      {url: `/api/me/profile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pickCreateProfileRequestExcludeKeyofCreateProfileRequestId
    },
      options);
    }
  


export const getCreateProfileMutationOptions = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProfile>>, {data: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId}> = (props) => {
          const {data} = props ?? {};

          return  createProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createProfile>>>
    export type CreateProfileMutationBody = PickCreateProfileRequestExcludeKeyofCreateProfileRequestId
    export type CreateProfileMutationError = ApiError

    export const useCreateProfile = <TError = ApiError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createProfile>>,
        TError,
        {data: PickCreateProfileRequestExcludeKeyofCreateProfileRequestId},
        TContext
      > => {

      const mutationOptions = getCreateProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const createUserBasicInfo = (
    pickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<CreateUserBasicInfoResponse>(
      {url: `/api/me/basic-info`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID
    },
      options);
    }
  


export const getCreateUserBasicInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserBasicInfo>>, TError,{data: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserBasicInfo>>, TError,{data: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserBasicInfo>>, {data: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID}> = (props) => {
          const {data} = props ?? {};

          return  createUserBasicInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserBasicInfoMutationResult = NonNullable<Awaited<ReturnType<typeof createUserBasicInfo>>>
    export type CreateUserBasicInfoMutationBody = PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID
    export type CreateUserBasicInfoMutationError = unknown

    export const useCreateUserBasicInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserBasicInfo>>, TError,{data: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createUserBasicInfo>>,
        TError,
        {data: PickCreateUserBasicInfoRequestExcludeKeyofCreateUserBasicInfoRequestFirebaseUID},
        TContext
      > => {

      const mutationOptions = getCreateUserBasicInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserPills = (
    params: GetUserPillsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserPillsResponse>(
      {url: `/api/me/pills`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserPillsQueryKey = (params: GetUserPillsParams,) => {
    return [`/api/me/pills`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserPillsQueryOptions = <TData = Awaited<ReturnType<typeof getUserPills>>, TError = unknown>(params: GetUserPillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPills>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPillsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPills>>> = ({ signal }) => getUserPills(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPills>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserPillsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPills>>>
export type GetUserPillsQueryError = unknown

export const useGetUserPills = <TData = Awaited<ReturnType<typeof getUserPills>>, TError = unknown>(
 params: GetUserPillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPills>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserPillsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserPills = async <TData = Awaited<ReturnType<typeof getUserPills>>, TError = unknown>(
 queryClient: QueryClient, params: GetUserPillsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPills>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserPillsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getCurrentMonthPointsRanking = (
    params: GetCurrentMonthPointsRankingParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetCurrentMonthPointsRankingResponse>(
      {url: `/api/me/points-ranking`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCurrentMonthPointsRankingQueryKey = (params: GetCurrentMonthPointsRankingParams,) => {
    return [`/api/me/points-ranking`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCurrentMonthPointsRankingQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError = unknown>(params: GetCurrentMonthPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentMonthPointsRankingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>> = ({ signal }) => getCurrentMonthPointsRanking(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentMonthPointsRankingQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>>
export type GetCurrentMonthPointsRankingQueryError = unknown

export const useGetCurrentMonthPointsRanking = <TData = Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError = unknown>(
 params: GetCurrentMonthPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCurrentMonthPointsRankingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetCurrentMonthPointsRanking = async <TData = Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError = unknown>(
 queryClient: QueryClient, params: GetCurrentMonthPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentMonthPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCurrentMonthPointsRankingQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getHistoryPointsRanking = (
    params: GetHistoryPointsRankingParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetHistoryPointsRankingResponse>(
      {url: `/api/me/points-ranking-history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHistoryPointsRankingQueryKey = (params: GetHistoryPointsRankingParams,) => {
    return [`/api/me/points-ranking-history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHistoryPointsRankingQueryOptions = <TData = Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError = unknown>(params: GetHistoryPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHistoryPointsRankingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHistoryPointsRanking>>> = ({ signal }) => getHistoryPointsRanking(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHistoryPointsRankingQueryResult = NonNullable<Awaited<ReturnType<typeof getHistoryPointsRanking>>>
export type GetHistoryPointsRankingQueryError = unknown

export const useGetHistoryPointsRanking = <TData = Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError = unknown>(
 params: GetHistoryPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHistoryPointsRankingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetHistoryPointsRanking = async <TData = Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError = unknown>(
 queryClient: QueryClient, params: GetHistoryPointsRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistoryPointsRanking>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetHistoryPointsRankingQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getFriendsAndFriendsRequests = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetFriendsAndFriendsRequestsResponse>(
      {url: `/api/me/friends`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFriendsAndFriendsRequestsQueryKey = () => {
    return [`/api/me/friends`] as const;
    }

    
export const getGetFriendsAndFriendsRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFriendsAndFriendsRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>> = ({ signal }) => getFriendsAndFriendsRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFriendsAndFriendsRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>>
export type GetFriendsAndFriendsRequestsQueryError = unknown

export const useGetFriendsAndFriendsRequests = <TData = Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFriendsAndFriendsRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetFriendsAndFriendsRequests = async <TData = Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFriendsAndFriendsRequests>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFriendsAndFriendsRequestsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const deleteFriend = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<DeleteFriendResponse>(
      {url: `/api/me/friends/${id}/delete`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFriendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFriend>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFriend>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteFriend(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFriendMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFriend>>>
    
    export type DeleteFriendMutationError = unknown

    export const useDeleteFriend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteFriend>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteFriendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const requestFriend = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<SendFriendRequestResponse>(
      {url: `/api/me/friends/${id}/request`, method: 'POST'
    },
      options);
    }
  


export const getRequestFriendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestFriend>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestFriend>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  requestFriend(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestFriendMutationResult = NonNullable<Awaited<ReturnType<typeof requestFriend>>>
    
    export type RequestFriendMutationError = unknown

    export const useRequestFriend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof requestFriend>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRequestFriendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const acceptFriend = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<AcceptFriendRequestResponse>(
      {url: `/api/me/friends/${id}/accept`, method: 'PUT'
    },
      options);
    }
  


export const getAcceptFriendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptFriend>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFriend>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptFriend(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptFriendMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFriend>>>
    
    export type AcceptFriendMutationError = unknown

    export const useAcceptFriend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof acceptFriend>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcceptFriendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const rejectFriend = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<RejectFriendRequestResponse>(
      {url: `/api/me/friends/${id}/reject`, method: 'PUT'
    },
      options);
    }
  


export const getRejectFriendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectFriend>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectFriend>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rejectFriend(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectFriendMutationResult = NonNullable<Awaited<ReturnType<typeof rejectFriend>>>
    
    export type RejectFriendMutationError = unknown

    export const useRejectFriend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectFriend>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof rejectFriend>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRejectFriendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const toggleShowCompany = (
    
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<ToggleShowCompanyResponse>(
      {url: `/api/me/toggle-show-company`, method: 'PUT'
    },
      options);
    }
  


export const getToggleShowCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleShowCompany>>, TError,void, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleShowCompany>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleShowCompany>>, void> = () => {
          

          return  toggleShowCompany(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleShowCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof toggleShowCompany>>>
    
    export type ToggleShowCompanyMutationError = unknown

    export const useToggleShowCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleShowCompany>>, TError,void, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof toggleShowCompany>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getToggleShowCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const toggleShowName = (
    
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<ToggleShowNameResponse>(
      {url: `/api/me/toggle-show-name`, method: 'PUT'
    },
      options);
    }
  


export const getToggleShowNameMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleShowName>>, TError,void, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleShowName>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleShowName>>, void> = () => {
          

          return  toggleShowName(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleShowNameMutationResult = NonNullable<Awaited<ReturnType<typeof toggleShowName>>>
    
    export type ToggleShowNameMutationError = unknown

    export const useToggleShowName = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleShowName>>, TError,void, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof toggleShowName>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getToggleShowNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const cancelFriendRequest = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<CancelFriendRequestResponse>(
      {url: `/api/me/friends/${id}/cancel`, method: 'PUT'
    },
      options);
    }
  


export const getCancelFriendRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFriendRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelFriendRequest>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFriendRequest>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelFriendRequest(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelFriendRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFriendRequest>>>
    
    export type CancelFriendRequestMutationError = unknown

    export const useCancelFriendRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFriendRequest>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelFriendRequest>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelFriendRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserConfig = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserConfigResponse>(
      {url: `/api/me/config`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserConfigQueryKey = () => {
    return [`/api/me/config`] as const;
    }

    
export const getGetUserConfigQueryOptions = <TData = Awaited<ReturnType<typeof getUserConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserConfig>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserConfig>>> = ({ signal }) => getUserConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getUserConfig>>>
export type GetUserConfigQueryError = unknown

export const useGetUserConfig = <TData = Awaited<ReturnType<typeof getUserConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserConfig>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserConfig = async <TData = Awaited<ReturnType<typeof getUserConfig>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserConfig>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserConfigQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getUserHabit = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserHabitResponse>(
      {url: `/api/me/habits`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserHabitQueryKey = () => {
    return [`/api/me/habits`] as const;
    }

    
export const getGetUserHabitQueryOptions = <TData = Awaited<ReturnType<typeof getUserHabit>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabit>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHabitQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHabit>>> = ({ signal }) => getUserHabit(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHabit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHabitQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHabit>>>
export type GetUserHabitQueryError = unknown

export const useGetUserHabit = <TData = Awaited<ReturnType<typeof getUserHabit>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabit>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHabitQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserHabit = async <TData = Awaited<ReturnType<typeof getUserHabit>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabit>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserHabitQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const updateUserHealthinessIdentity = (
    updateUserHealthinessIdentityBody: UpdateUserHealthinessIdentityBody,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateUserHealthinessIdentityResponse>(
      {url: `/api/me/update-healthiness-identity`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserHealthinessIdentityBody
    },
      options);
    }
  


export const getUpdateUserHealthinessIdentityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserHealthinessIdentity>>, TError,{data: UpdateUserHealthinessIdentityBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserHealthinessIdentity>>, TError,{data: UpdateUserHealthinessIdentityBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserHealthinessIdentity>>, {data: UpdateUserHealthinessIdentityBody}> = (props) => {
          const {data} = props ?? {};

          return  updateUserHealthinessIdentity(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserHealthinessIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserHealthinessIdentity>>>
    export type UpdateUserHealthinessIdentityMutationBody = UpdateUserHealthinessIdentityBody
    export type UpdateUserHealthinessIdentityMutationError = unknown

    export const useUpdateUserHealthinessIdentity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserHealthinessIdentity>>, TError,{data: UpdateUserHealthinessIdentityBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserHealthinessIdentity>>,
        TError,
        {data: UpdateUserHealthinessIdentityBody},
        TContext
      > => {

      const mutationOptions = getUpdateUserHealthinessIdentityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateUserHabitCommitment = (
    updateUserHabitCommitmentBody: UpdateUserHabitCommitmentBody,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateHabitCommitmentResponse>(
      {url: `/api/me/update-habit-commitment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserHabitCommitmentBody
    },
      options);
    }
  


export const getUpdateUserHabitCommitmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserHabitCommitment>>, TError,{data: UpdateUserHabitCommitmentBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserHabitCommitment>>, TError,{data: UpdateUserHabitCommitmentBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserHabitCommitment>>, {data: UpdateUserHabitCommitmentBody}> = (props) => {
          const {data} = props ?? {};

          return  updateUserHabitCommitment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserHabitCommitmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserHabitCommitment>>>
    export type UpdateUserHabitCommitmentMutationBody = UpdateUserHabitCommitmentBody
    export type UpdateUserHabitCommitmentMutationError = unknown

    export const useUpdateUserHabitCommitment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserHabitCommitment>>, TError,{data: UpdateUserHabitCommitmentBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserHabitCommitment>>,
        TError,
        {data: UpdateUserHabitCommitmentBody},
        TContext
      > => {

      const mutationOptions = getUpdateUserHabitCommitmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserPillsShowcase = (
    params: GetUserPillsShowcaseParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserPillsShowcaseResponse>(
      {url: `/api/me/pills/showcase`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserPillsShowcaseQueryKey = (params: GetUserPillsShowcaseParams,) => {
    return [`/api/me/pills/showcase`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserPillsShowcaseQueryOptions = <TData = Awaited<ReturnType<typeof getUserPillsShowcase>>, TError = unknown>(params: GetUserPillsShowcaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPillsShowcase>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPillsShowcaseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPillsShowcase>>> = ({ signal }) => getUserPillsShowcase(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPillsShowcase>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserPillsShowcaseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPillsShowcase>>>
export type GetUserPillsShowcaseQueryError = unknown

export const useGetUserPillsShowcase = <TData = Awaited<ReturnType<typeof getUserPillsShowcase>>, TError = unknown>(
 params: GetUserPillsShowcaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPillsShowcase>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserPillsShowcaseQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserPillsShowcase = async <TData = Awaited<ReturnType<typeof getUserPillsShowcase>>, TError = unknown>(
 queryClient: QueryClient, params: GetUserPillsShowcaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPillsShowcase>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserPillsShowcaseQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const unlockUserPill = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UnlockUserPillResponse>(
      {url: `/api/me/pills/${id}/unlock`, method: 'PUT'
    },
      options);
    }
  


export const getUnlockUserPillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockUserPill>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockUserPill>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockUserPill>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unlockUserPill(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnlockUserPillMutationResult = NonNullable<Awaited<ReturnType<typeof unlockUserPill>>>
    
    export type UnlockUserPillMutationError = unknown

    export const useUnlockUserPill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockUserPill>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof unlockUserPill>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUnlockUserPillMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const readUserPill = (
    id: string,
    pickUserPillEntityPropsRateOrUserDurationOrConclusionOpened: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<ReadUserPillResponse>(
      {url: `/api/me/pills/${id}/read`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pickUserPillEntityPropsRateOrUserDurationOrConclusionOpened
    },
      options);
    }
  


export const getReadUserPillMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readUserPill>>, TError,{id: string;data: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof readUserPill>>, TError,{id: string;data: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readUserPill>>, {id: string;data: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened}> = (props) => {
          const {id,data} = props ?? {};

          return  readUserPill(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReadUserPillMutationResult = NonNullable<Awaited<ReturnType<typeof readUserPill>>>
    export type ReadUserPillMutationBody = PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened
    export type ReadUserPillMutationError = unknown

    export const useReadUserPill = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readUserPill>>, TError,{id: string;data: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof readUserPill>>,
        TError,
        {id: string;data: PickUserPillEntityPropsRateOrUserDurationOrConclusionOpened},
        TContext
      > => {

      const mutationOptions = getReadUserPillMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserCoachStatus = (
    params: GetUserCoachStatusParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserCoachStatusResponse>(
      {url: `/api/me/coach/status`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserCoachStatusQueryKey = (params: GetUserCoachStatusParams,) => {
    return [`/api/me/coach/status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserCoachStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserCoachStatus>>, TError = unknown>(params: GetUserCoachStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCoachStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserCoachStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCoachStatus>>> = ({ signal }) => getUserCoachStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserCoachStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserCoachStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserCoachStatus>>>
export type GetUserCoachStatusQueryError = unknown

export const useGetUserCoachStatus = <TData = Awaited<ReturnType<typeof getUserCoachStatus>>, TError = unknown>(
 params: GetUserCoachStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCoachStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserCoachStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserCoachStatus = async <TData = Awaited<ReturnType<typeof getUserCoachStatus>>, TError = unknown>(
 queryClient: QueryClient, params: GetUserCoachStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCoachStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserCoachStatusQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getUserCatalog = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserCatalogResponse>(
      {url: `/api/me/catalog`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserCatalogQueryKey = () => {
    return [`/api/me/catalog`] as const;
    }

    
export const getGetUserCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getUserCatalog>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCatalog>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserCatalogQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCatalog>>> = ({ signal }) => getUserCatalog(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getUserCatalog>>>
export type GetUserCatalogQueryError = unknown

export const useGetUserCatalog = <TData = Awaited<ReturnType<typeof getUserCatalog>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCatalog>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserCatalog = async <TData = Awaited<ReturnType<typeof getUserCatalog>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserCatalog>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserCatalogQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getUserWork = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserWorkResponse>(
      {url: `/api/me/wellness/work`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserWorkQueryKey = () => {
    return [`/api/me/wellness/work`] as const;
    }

    
export const getGetUserWorkQueryOptions = <TData = Awaited<ReturnType<typeof getUserWork>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWork>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserWorkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserWork>>> = ({ signal }) => getUserWork(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserWork>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserWorkQueryResult = NonNullable<Awaited<ReturnType<typeof getUserWork>>>
export type GetUserWorkQueryError = unknown

export const useGetUserWork = <TData = Awaited<ReturnType<typeof getUserWork>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWork>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserWorkQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserWork = async <TData = Awaited<ReturnType<typeof getUserWork>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWork>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserWorkQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const createUserWork = (
    createUserWorkBody: CreateUserWorkBody,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<CreateUserWork200>(
      {url: `/api/me/wellness/work`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserWorkBody
    },
      options);
    }
  


export const getCreateUserWorkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserWork>>, TError,{data: CreateUserWorkBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserWork>>, TError,{data: CreateUserWorkBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserWork>>, {data: CreateUserWorkBody}> = (props) => {
          const {data} = props ?? {};

          return  createUserWork(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserWorkMutationResult = NonNullable<Awaited<ReturnType<typeof createUserWork>>>
    export type CreateUserWorkMutationBody = CreateUserWorkBody
    export type CreateUserWorkMutationError = unknown

    export const useCreateUserWork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserWork>>, TError,{data: CreateUserWorkBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createUserWork>>,
        TError,
        {data: CreateUserWorkBody},
        TContext
      > => {

      const mutationOptions = getCreateUserWorkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserSports = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserSportsResponse>(
      {url: `/api/me/wellness/spots`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserSportsQueryKey = () => {
    return [`/api/me/wellness/spots`] as const;
    }

    
export const getGetUserSportsQueryOptions = <TData = Awaited<ReturnType<typeof getUserSports>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSports>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSportsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSports>>> = ({ signal }) => getUserSports(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSports>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSportsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSports>>>
export type GetUserSportsQueryError = unknown

export const useGetUserSports = <TData = Awaited<ReturnType<typeof getUserSports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSports>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserSports = async <TData = Awaited<ReturnType<typeof getUserSports>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSports>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserSportsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const saveUserSports = (
    saveUserSportsBody: SaveUserSportsBody,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<SaveUserSports200>(
      {url: `/api/me/wellness/spots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveUserSportsBody
    },
      options);
    }
  


export const getSaveUserSportsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveUserSports>>, TError,{data: SaveUserSportsBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveUserSports>>, TError,{data: SaveUserSportsBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveUserSports>>, {data: SaveUserSportsBody}> = (props) => {
          const {data} = props ?? {};

          return  saveUserSports(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveUserSportsMutationResult = NonNullable<Awaited<ReturnType<typeof saveUserSports>>>
    export type SaveUserSportsMutationBody = SaveUserSportsBody
    export type SaveUserSportsMutationError = unknown

    export const useSaveUserSports = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveUserSports>>, TError,{data: SaveUserSportsBody}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof saveUserSports>>,
        TError,
        {data: SaveUserSportsBody},
        TContext
      > => {

      const mutationOptions = getSaveUserSportsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserWorkOfTheDay = (
    work: Work,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserWorkOfTheDayResponse>(
      {url: `/api/me/wellness/work/${work}/wod`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserWorkOfTheDayQueryKey = (work: Work,) => {
    return [`/api/me/wellness/work/${work}/wod`] as const;
    }

    
export const getGetUserWorkOfTheDayQueryOptions = <TData = Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError = unknown>(work: Work, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserWorkOfTheDayQueryKey(work);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserWorkOfTheDay>>> = ({ signal }) => getUserWorkOfTheDay(work, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(work), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserWorkOfTheDayQueryResult = NonNullable<Awaited<ReturnType<typeof getUserWorkOfTheDay>>>
export type GetUserWorkOfTheDayQueryError = unknown

export const useGetUserWorkOfTheDay = <TData = Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError = unknown>(
 work: Work, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserWorkOfTheDayQueryOptions(work,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserWorkOfTheDay = async <TData = Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError = unknown>(
 queryClient: QueryClient, work: Work, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserWorkOfTheDay>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserWorkOfTheDayQueryOptions(work,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const updateProfileNotifications = (
    pickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateProfileNotificationsResponse>(
      {url: `/api/me/profile/notifications`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID
    },
      options);
    }
  


export const getUpdateProfileNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileNotifications>>, TError,{data: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfileNotifications>>, TError,{data: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfileNotifications>>, {data: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID}> = (props) => {
          const {data} = props ?? {};

          return  updateProfileNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfileNotifications>>>
    export type UpdateProfileNotificationsMutationBody = PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID
    export type UpdateProfileNotificationsMutationError = unknown

    export const useUpdateProfileNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileNotifications>>, TError,{data: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateProfileNotifications>>,
        TError,
        {data: PickUpdateProfileNotificationsRequestExcludeKeyofUpdateProfileNotificationsRequestFirebaseUID},
        TContext
      > => {

      const mutationOptions = getUpdateProfileNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserStatsCalendar = (
    params?: GetUserStatsCalendarParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserStatsCalendarResponse>(
      {url: `/api/me/stats/calendar`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserStatsCalendarQueryKey = (params?: GetUserStatsCalendarParams,) => {
    return [`/api/me/stats/calendar`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserStatsCalendarQueryOptions = <TData = Awaited<ReturnType<typeof getUserStatsCalendar>>, TError = unknown>(params?: GetUserStatsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsCalendar>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatsCalendarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatsCalendar>>> = ({ signal }) => getUserStatsCalendar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStatsCalendar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserStatsCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStatsCalendar>>>
export type GetUserStatsCalendarQueryError = unknown

export const useGetUserStatsCalendar = <TData = Awaited<ReturnType<typeof getUserStatsCalendar>>, TError = unknown>(
 params?: GetUserStatsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsCalendar>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserStatsCalendarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserStatsCalendar = async <TData = Awaited<ReturnType<typeof getUserStatsCalendar>>, TError = unknown>(
 queryClient: QueryClient, params?: GetUserStatsCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsCalendar>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserStatsCalendarQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getUserStatsHistory = (
    params?: GetUserStatsHistoryParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserStatsHistoryResponse>(
      {url: `/api/me/stats/history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserStatsHistoryQueryKey = (params?: GetUserStatsHistoryParams,) => {
    return [`/api/me/stats/history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserStatsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getUserStatsHistory>>, TError = unknown>(params?: GetUserStatsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatsHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatsHistory>>> = ({ signal }) => getUserStatsHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStatsHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserStatsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStatsHistory>>>
export type GetUserStatsHistoryQueryError = unknown

export const useGetUserStatsHistory = <TData = Awaited<ReturnType<typeof getUserStatsHistory>>, TError = unknown>(
 params?: GetUserStatsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserStatsHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUserStatsHistory = async <TData = Awaited<ReturnType<typeof getUserStatsHistory>>, TError = unknown>(
 queryClient: QueryClient, params?: GetUserStatsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatsHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserStatsHistoryQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getMyUser = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetMyUserResponse>(
      {url: `/api/me`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMyUserQueryKey = () => {
    return [`/api/me`] as const;
    }

    
export const getGetMyUserQueryOptions = <TData = Awaited<ReturnType<typeof getMyUser>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUser>>> = ({ signal }) => getMyUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyUserQueryResult = NonNullable<Awaited<ReturnType<typeof getMyUser>>>
export type GetMyUserQueryError = unknown

export const useGetMyUser = <TData = Awaited<ReturnType<typeof getMyUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMyUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetMyUser = async <TData = Awaited<ReturnType<typeof getMyUser>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetMyUserQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const registerUser = (
    pickRegisterRequestNameOrPartnerCode: PickRegisterRequestNameOrPartnerCode,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<RegisterUser200>(
      {url: `/api/me/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pickRegisterRequestNameOrPartnerCode
    },
      options);
    }
  


export const getRegisterUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: PickRegisterRequestNameOrPartnerCode}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: PickRegisterRequestNameOrPartnerCode}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUser>>, {data: PickRegisterRequestNameOrPartnerCode}> = (props) => {
          const {data} = props ?? {};

          return  registerUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterUserMutationResult = NonNullable<Awaited<ReturnType<typeof registerUser>>>
    export type RegisterUserMutationBody = PickRegisterRequestNameOrPartnerCode
    export type RegisterUserMutationError = unknown

    export const useRegisterUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: PickRegisterRequestNameOrPartnerCode}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerUser>>,
        TError,
        {data: PickRegisterRequestNameOrPartnerCode},
        TContext
      > => {

      const mutationOptions = getRegisterUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const joinWebinar = (
    pickJoinWebinarRequestWebinarId: PickJoinWebinarRequestWebinarId,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<JoinWebinarResponse>(
      {url: `/api/me/join-webinar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pickJoinWebinarRequestWebinarId
    },
      options);
    }
  


export const getJoinWebinarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWebinar>>, TError,{data: PickJoinWebinarRequestWebinarId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinWebinar>>, TError,{data: PickJoinWebinarRequestWebinarId}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinWebinar>>, {data: PickJoinWebinarRequestWebinarId}> = (props) => {
          const {data} = props ?? {};

          return  joinWebinar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinWebinarMutationResult = NonNullable<Awaited<ReturnType<typeof joinWebinar>>>
    export type JoinWebinarMutationBody = PickJoinWebinarRequestWebinarId
    export type JoinWebinarMutationError = unknown

    export const useJoinWebinar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWebinar>>, TError,{data: PickJoinWebinarRequestWebinarId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof joinWebinar>>,
        TError,
        {data: PickJoinWebinarRequestWebinarId},
        TContext
      > => {

      const mutationOptions = getJoinWebinarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const disjoinWebinar = (
    pickDisjoinWebinarRequestWebinarId: PickDisjoinWebinarRequestWebinarId,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<DisjoinWebinarResponse>(
      {url: `/api/me/disjoin-webinar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pickDisjoinWebinarRequestWebinarId
    },
      options);
    }
  


export const getDisjoinWebinarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disjoinWebinar>>, TError,{data: PickDisjoinWebinarRequestWebinarId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disjoinWebinar>>, TError,{data: PickDisjoinWebinarRequestWebinarId}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disjoinWebinar>>, {data: PickDisjoinWebinarRequestWebinarId}> = (props) => {
          const {data} = props ?? {};

          return  disjoinWebinar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisjoinWebinarMutationResult = NonNullable<Awaited<ReturnType<typeof disjoinWebinar>>>
    export type DisjoinWebinarMutationBody = PickDisjoinWebinarRequestWebinarId
    export type DisjoinWebinarMutationError = unknown

    export const useDisjoinWebinar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disjoinWebinar>>, TError,{data: PickDisjoinWebinarRequestWebinarId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof disjoinWebinar>>,
        TError,
        {data: PickDisjoinWebinarRequestWebinarId},
        TContext
      > => {

      const mutationOptions = getDisjoinWebinarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateAccountFields = (
    pickUpdateAccountFieldsRequestNameOrLangOrImage: PickUpdateAccountFieldsRequestNameOrLangOrImage,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateAccountFieldsResponse>(
      {url: `/api/me/update-account-fields`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pickUpdateAccountFieldsRequestNameOrLangOrImage
    },
      options);
    }
  


export const getUpdateAccountFieldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountFields>>, TError,{data: PickUpdateAccountFieldsRequestNameOrLangOrImage}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountFields>>, TError,{data: PickUpdateAccountFieldsRequestNameOrLangOrImage}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountFields>>, {data: PickUpdateAccountFieldsRequestNameOrLangOrImage}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountFields(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountFields>>>
    export type UpdateAccountFieldsMutationBody = PickUpdateAccountFieldsRequestNameOrLangOrImage
    export type UpdateAccountFieldsMutationError = unknown

    export const useUpdateAccountFields = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountFields>>, TError,{data: PickUpdateAccountFieldsRequestNameOrLangOrImage}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountFields>>,
        TError,
        {data: PickUpdateAccountFieldsRequestNameOrLangOrImage},
        TContext
      > => {

      const mutationOptions = getUpdateAccountFieldsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateProfileFields = (
    pickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateProfileFieldsResponse>(
      {url: `/api/me/update-profile-fields`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities
    },
      options);
    }
  


export const getUpdateProfileFieldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileFields>>, TError,{data: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfileFields>>, TError,{data: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfileFields>>, {data: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities}> = (props) => {
          const {data} = props ?? {};

          return  updateProfileFields(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfileFields>>>
    export type UpdateProfileFieldsMutationBody = PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities
    export type UpdateProfileFieldsMutationError = unknown

    export const useUpdateProfileFields = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileFields>>, TError,{data: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateProfileFields>>,
        TError,
        {data: PickUpdateProfileFieldsRequestAgeOrGenderOrMaterialOrDisabilities},
        TContext
      > => {

      const mutationOptions = getUpdateProfileFieldsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    